import { render, staticRenderFns } from "./social-media.vue?vue&type=template&id=485e3b30&scoped=true&"
import script from "./social-media.vue?vue&type=script&lang=js&"
export * from "./social-media.vue?vue&type=script&lang=js&"
import style0 from "./social-media.vue?vue&type=style&index=0&id=485e3b30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485e3b30",
  null
  
)

export default component.exports